<template>
    <div class="step-indicator">
        <div class="step-indicator__label text-caption text-grey mb-2">
            Step {{ currentStep }} of {{ totalSteps }}
        </div>
        <div class="step-indicator__track d-flex align-center justify-center">
            <template v-for="(label, index) in labels" :key="index">
                <!-- Circle -->
                <div class="step-indicator__circle"
                     :class="{
                         'step-indicator__circle--active': index + 1 === currentStep,
                         'step-indicator__circle--completed': index + 1 < currentStep,
                         'step-indicator__circle--pending': index + 1 > currentStep,
                     }">
                    <v-icon v-if="index + 1 < currentStep" size="16" color="white">mdi-check</v-icon>
                    <span v-else class="step-indicator__number">{{ index + 1 }}</span>
                </div>
                <!-- Line between circles -->
                <div v-if="index < labels.length - 1"
                     class="step-indicator__line"
                     :class="{ 'step-indicator__line--completed': index + 1 < currentStep }"/>
            </template>
        </div>
        <div class="step-indicator__labels d-flex justify-space-between mt-1">
            <span v-for="(label, index) in labels" :key="'label-' + index"
                  class="step-indicator__label-text text-caption"
                  :class="{
                      'font-weight-bold text-primary': index + 1 <= currentStep,
                      'text-grey-lighten-1': index + 1 > currentStep,
                  }">
                {{ label }}
            </span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    currentStep: {
        type: Number,
        required: true,
    },
    totalSteps: {
        type: Number,
        default: 3,
    },
    labels: {
        type: Array,
        default: () => ['Account', 'Verify', 'Business'],
    },
});
</script>

<style scoped>
.step-indicator {
    padding: 8px 16px 4px;
}

.step-indicator__label {
    text-align: center;
}

.step-indicator__track {
    gap: 0;
}

.step-indicator__circle {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.step-indicator__circle--active {
    background: linear-gradient(135deg, #551A8B, #7B2FA0);
    color: white;
    box-shadow: 0 2px 8px rgba(85, 26, 139, 0.3);
}

.step-indicator__circle--completed {
    background: #551A8B;
    color: white;
}

.step-indicator__circle--pending {
    background: white;
    border: 2px solid #E0E0E0;
    color: #9E9E9E;
}

.step-indicator__line {
    flex: 1;
    height: 2px;
    background: #E0E0E0;
    margin: 0 4px;
    transition: background 0.3s ease;
}

.step-indicator__line--completed {
    background: #551A8B;
}

.step-indicator__labels {
    padding: 0 4px;
}

.step-indicator__label-text {
    width: 32px;
    text-align: center;
    font-size: 11px !important;
    white-space: nowrap;
}

.step-indicator__number {
    font-size: 13px;
}
</style>
